import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { CompareProvider } from "@/context/CompareContext";
import { FavoritesProvider } from "@/context/FavoritesContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { Layout } from "@/components/Layout";
import { Toaster } from "@/components/ui/sonner";

import Home from "@/pages/Home";
import Buscar from "@/pages/Buscar";
import Comparar from "@/pages/Comparar";
import AnuncioDetalhe from "@/pages/AnuncioDetalhe";
import CriarAnuncio from "@/pages/CriarAnuncio";
import EditarAnuncio from "@/pages/EditarAnuncio";
import MeusAnuncios from "@/pages/MeusAnuncios";
import Alertas from "@/pages/Alertas";
import Mensagens from "@/pages/Mensagens";
import Favoritos from "@/pages/Favoritos";
import AdminDenuncias from "@/pages/AdminDenuncias";
import Cartaz from "@/pages/Cartaz";
import ComoFunciona from "@/pages/ComoFunciona";
import Materiais from "@/pages/Materiais";
import Precos from "@/pages/Precos";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import AuthCallback from "@/pages/AuthCallback";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (pathname === "/buscar") return; // Buscar gerencia seu próprio scroll (restaura a posição da lista)
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);
  return null;
}

function AppRouter() {
  const location = useLocation();
  // Detect Google OAuth callback synchronously (fragment) before any protected route runs.
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/buscar" element={<Buscar />} />
        <Route path="/comparar" element={<Comparar />} />
        <Route path="/anuncio/:id" element={<AnuncioDetalhe />} />
        <Route path="/como-funciona" element={<ComoFunciona />} />
        <Route path="/materiais" element={<Materiais />} />
        <Route path="/precos" element={<Precos />} />
        <Route path="/anunciar" element={<ProtectedRoute><CriarAnuncio /></ProtectedRoute>} />
        <Route path="/editar/:id" element={<ProtectedRoute><EditarAnuncio /></ProtectedRoute>} />
        <Route path="/painel" element={<ProtectedRoute><MeusAnuncios /></ProtectedRoute>} />
        <Route path="/alertas" element={<ProtectedRoute><Alertas /></ProtectedRoute>} />
        <Route path="/mensagens" element={<ProtectedRoute><Mensagens /></ProtectedRoute>} />
        <Route path="/favoritos" element={<ProtectedRoute><Favoritos /></ProtectedRoute>} />
        <Route path="/admin/denuncias" element={<ProtectedRoute><AdminDenuncias /></ProtectedRoute>} />
      </Route>
      <Route path="/cartaz/:id" element={<ProtectedRoute><Cartaz /></ProtectedRoute>} />
      <Route path="/entrar" element={<Login />} />
      <Route path="/cadastrar" element={<Register />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <CompareProvider>
            <FavoritesProvider>
              <ScrollToTop />
              <AppRouter />
              <Toaster position="top-center" richColors />
            </FavoritesProvider>
          </CompareProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
